import { atom } from "jotai";
import { atomFamily } from "jotai-family";

/** Ticket kind ID from event_ticket_kind[0].id. */
export const eventTicketKindIdFamily = atomFamily((_slug: string) =>
  atom<null | string>(null),
);
